// @TODO cleanup leftover code, create GravityFormHtml component
import React, { Suspense, useContext, useEffect, useRef, useState } from "react"
import * as ReactDOM from "react-dom"
import parse, {
  DOMNode,
  Element,
  HTMLReactParserOptions,
  domToReact,
  Text,
} from "html-react-parser"
// import DOMPurify from "dompurify"

import isElement from "../utils/is-element"
import { Script, Slice } from "gatsby"
import { attributesToProps } from "html-react-parser"
import isScript from "../utils/is-script"
import classNames from "../utils/classnames"
import isText from "../utils/is-text"
import isComment from "../utils/is-comment"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import useIsAtViewportTop from "../utils/useIsAtViewportTop"
import { Transition } from "@headlessui/react"
import useIsInViewport from "../utils/useIsInViewport"
import ChevronIcon from "../icons/chevron"
import {
  ReactCompareSlider,
  ReactCompareSliderHandle,
} from "react-compare-slider"
import Tabs, { TabContent, TabItem, TabLink, TabList } from "./tabs"
import BlockGallerySlider, {
  BlockGallerySliderItem,
} from "./block-gallery-slider"
import ProgramDeliveryTable from "./program-delivery-table"
import Link from "./link"
import WpImage from "./wp-image"
import WpGallery from "./wp-gallery"
import IframeGravityForm from "./iframe-gravity-form"
import Loading from "./loading"
import ProgramCoursesListingBlock from "./blocks/georgiancollege-program-courses-listing"

const GcCourseListing = React.lazy(() => import(`./blocks/course-listing`))
const PtsProgramFilters = React.lazy(() => import(`./pts-program-filters`))
const HomepageFeedsSlices = React.lazy(() => import(`./homepage-feeds-slices`))
const PtsProgramListing = React.lazy(() => import(`./pts-program-listing`))
const PtsCourseListing = React.lazy(() => import(`./pts-course-listing`))
const PtsFilters = React.lazy(() => import(`./pts-filters`))
const GcFilters = React.lazy(() => import(`./gc-filters`))
const ArticulationListing = React.lazy(() => import(`./articulations-listing`))
//const FulltimeProgramList = React.lazy(() => import(`./fulltime-program-list`))
const ProgramListing = React.lazy(() => import(`./blocks/program-listing`))
const ProgramOutlineLookup = React.lazy(
  () => import(`./program-outline-lookup`)
)
const StandaloneEventCalendar = React.lazy(
  () => import(`./standalone-event-calendar`)
)
const CecsJobsList = React.lazy(() => import(`./cecs-jobs`))
const Ieeg = React.lazy(() => import(`./ieeg`))

interface IWordpressContentProps {
  html: string
  // sanitize?: boolean
}

export const options: HTMLReactParserOptions = {
  replace: (domNode: DOMNode) => {
    // console.log({ domNode })
    // replace script tags with gatsby <Script>
    if (isScript(domNode)) {
      if (domNode.attribs.type === `wordpress/block`) {
        // fully headless wp block must replace with react component
        const text = domNode.children[0] as Text
        const attributes = JSON.parse(text.data)

        if (
          domNode.attribs.class.includes(
            `wp-block-georgiancollege-program-courses-listing`
          )
        ) {
          return <ProgramCoursesListingBlock {...attributes} />
        } else if (
          domNode?.attribs?.class?.includes(
            `wp-block-georgiancollege-course-listing`
          )
        ) {
          return (
            <Suspense fallback={<Loading />}>
              <GcCourseListing />
            </Suspense>
          )
        } else if (
          domNode?.attribs?.class?.includes(
            `wp-block-georgiancollege-program-listing`
          )
        ) {
          return (
            <Suspense fallback={<Loading />}>
              <ProgramListing {...attributes} />
            </Suspense>
          )
        }
        // default, just return the original script/template
        return (
          <script {...domNode.attribs}>{JSON.stringify(attributes)}</script>
        )
      }
      if (domNode.attribs.type === `application/json+ld`) {
        return null // temporary fix/removal of broken json+ld script tags
        const text = domNode.children[0] as Text
        const str = text.data
          .replace(`"Georgian College",`, `"Georgian College"`)
          .replace(`"Georgian College",`, `"Georgian College"`)
          .replace(`},\n\t\t\t}`, `}}`)
        const data = JSON.parse(str)
        return (
          <script
            {...attributesToProps(domNode.attribs)}
            type="application/ld+json"
          >
            {JSON.stringify(data)}
          </script>
        )
      }
      return (
        <Script {...attributesToProps(domNode.attribs)}>
          {domToReact(domNode.children, {
            replace: (domNode: DOMNode): JSX.Element => {
              if (isText(domNode) && !isComment(domNode)) return domNode
              return <></>
            },
          }).toString()}
        </Script>
      )
    }
    if (isElement(domNode)) {
      // replace faqs onclick
      if (
        domNode?.attribs?.class?.includes(`faq-question-wrapper`) ||
        domNode?.attribs?.class?.includes(`accordion-title-wrapper`)
      ) {
        return (
          <div
            {...attributesToProps(domNode?.attribs)}
            onClick={
              domNode?.attribs?.onclick
                ? (): void => Function(domNode?.attribs?.onclick)()
                : undefined
            }
          >
            {domToReact(domNode.children, options)}
          </div>
        )
      }
      // replace wp-gallery
      if (
        domNode?.attribs?.class?.includes(`wp-block-gallery`) &&
        !domNode?.attribs?.class?.includes(`wp-block-gallery-slider`)
      ) {
        return (
          <WpGallery {...domNode?.attribs}>
            {domToReact(domNode.children)}
          </WpGallery>
        )
      }
      // replace wp-images
      // if (domNode?.attribs?.class?.includes(`wp-image`)) {
      //   return <WpImage {...domNode?.attribs} />
      // }
      // replace .wp-block-georgiancollege-programoutline-lookup
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-programoutline-lookup`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <ProgramOutlineLookup />
          </Suspense>
        )
      }
      // replace .wp-block-georgiancollege-event-calendar
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-event-calendar`
        )
      ) {
        // console.log({ attribs: domNode?.attribs })
        return (
          <Suspense fallback={<Loading />}>
            <StandaloneEventCalendar
              categories={domNode?.attribs[`data-categories`]}
              showCategories={
                domNode?.attribs[`data-showcategories`] === `true` ?? false
              }
            />
          </Suspense>
        )
      }

      // replace cecs jobs list with custom component
      if (domNode?.attribs?.id?.includes(`cces-job-listing-div`)) {
        return (
          <Suspense fallback={<Loading />}>
            <CecsJobsList />
          </Suspense>
        )
      }
      // replace fulltime program list with custom component
      /*if (domNode?.attribs?.id?.includes(`ft-program-list`)) {
        return (
          <Suspense fallback={<Loading />}>
            <FulltimeProgramList />
          </Suspense>
        )
      }*/
      // replace .wp-block-georgian-articulations with custom articulations list
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-articulations`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <ArticulationListing />
          </Suspense>
        )
      }
      // replace .wp-block-georgian-pts-program-listing
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-pts-program-listing`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <PtsProgramListing />
          </Suspense>
        )
      }
      // replace .wp-block-georgian-pts-filters
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-pts-filters`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <PtsFilters />
          </Suspense>
        )
      }
      // replace .wp-block-georgian-pts-filters
      if (
        domNode?.attribs?.class?.includes(`wp-block-georgiancollege-gc-filters`)
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <GcFilters />
          </Suspense>
        )
      }
      // replace .wp-block-georgian-pts-program-filters
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-pts-program-filters`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <PtsProgramFilters />
          </Suspense>
        )
      }
      // replace .wp-block-georgian-pts-course-listing
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-pts-course-listing`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <PtsCourseListing />
          </Suspense>
        )
      }

      // replace GC Table of Contents block
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-table-of-contents`
        )
      ) {
        delete domNode?.attribs?.class
        return <TableOfContentsBlock domNode={domNode} />
      }
      // replace headings
      if (
        domNode?.name === `h1` ||
        domNode?.name === `h2` ||
        domNode?.name === `h3` ||
        domNode?.name === `h4` ||
        domNode?.name === `h5` ||
        domNode?.name === `h6`
      ) {
        return <Heading domNode={domNode} />
      }
      // replace anchor links
      if (domNode?.name === `a` && domNode?.attribs?.href?.indexOf(`#`) === 0) {
        return <AnchorLink domNode={domNode} />
      }
      // replace gravity forms
      if (domNode?.attribs?.class?.includes(`gform_wrapper`)) {
        return <IframeGravityForm domNode={domNode} />
        // return <HtmlGravityForm domNode={domNode} />
      }
      // replace tabs
      if (domNode?.attribs?.class?.includes(`wp-block-georgiancollege-tabs`)) {
        return <Tabs>{domToReact(domNode.children, options)}</Tabs>
      }
      if (domNode?.attribs?.class?.includes(`nav-tabs`)) {
        return <TabList>{domToReact(domNode.children, options)}</TabList>
      }
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-tab-content`
        )
      ) {
        return (
          <TabContent attribs={domNode?.attribs}>
            {domToReact(domNode.children, options)}
          </TabContent>
        )
      }

      if (domNode?.attribs && domNode.attribs[`data-toggle`]?.includes(`tab`)) {
        return (
          <TabLink attribs={domNode?.attribs}>
            {domToReact(domNode.children, options)}
          </TabLink>
        )
      }
      // replace program delivery table
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-program-delivery`
        )
      ) {
        return (
          <ProgramDeliveryTable {...domNode?.attribs}>
            {domToReact(domNode.children, options)}
          </ProgramDeliveryTable>
        )
      }
      // block-gallery-slider
      if (
        domNode?.attribs?.class?.includes(`blocks-gallery-slider`) ||
        domNode?.attribs?.class?.includes(`advgb-images-slider`)
      ) {
        return (
          <BlockGallerySlider>
            {domToReact(domNode.children, options)}
          </BlockGallerySlider>
        )
      }
      if (
        domNode?.attribs?.class?.includes(`blocks-gallery-item`) ||
        domNode?.attribs?.class?.includes(`advgb-image-slider-item`)
      ) {
        return (
          <BlockGallerySliderItem attribs={domNode?.attribs}>
            {domToReact(domNode.children)}
          </BlockGallerySliderItem>
        )
      }

      // replace homepage blog stuff
      if (domNode?.attribs?.class?.includes(`mid-banner2`)) {
        return <></> // remove mid-banner2
      }
      // replace homepage last row/feeds with custom feeds
      if (
        domNode?.attribs?.class?.includes(
          `wp-block-georgiancollege-homepage-feeds`
        )
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <HomepageFeedsSlices />
          </Suspense>
        )
      }

      // replace relative links
      if (domNode?.name === `a` && domNode?.attribs?.href?.indexOf(`/`) === 0) {
        const to = domNode.attribs.href
        delete domNode.attribs.href
        return (
          <Link to={to} {...attributesToProps(domNode.attribs)}>
            {domToReact(domNode.children, options)}
          </Link>
        )
      }

      // replace IEEG block
      if (
        domNode?.attribs?.id === `selCountry` ||
        domNode?.attribs?.class?.includes(`wp-block-georgiancollege-ieeg`)
      ) {
        return (
          <Suspense fallback={<Loading />}>
            <Ieeg />
          </Suspense>
        )
      }

      // example replacement
      if (domNode?.attribs?.class) {
        switch (domNode.attribs.class) {
          case `example-replace-class`:
            return (
              <div className="replaced-element">
                {domToReact(domNode.children, options)}
              </div>
            )
        }
      }
    }
    return domNode
  },
}

const WordpressContent = ({
  html,
}: // sanitize = false,
  IWordpressContentProps): JSX.Element => {
  const [previewHtml, setPreviewHtml] = useState(null)
  const [previewType, setPreviewType] = useState(`draft`)
  const { tocPortalRef } = useContext(UserInterfaceContext)
  const pageRef = useRef(null)

  useEffect(() => {
    const onMessage = function (e): void {
      // console.log({ e })
      if (
        e.origin !== `http://localhost:8000` &&
        e.origin !== `https://content.georgiancollege.ca` &&
        e.origin !== `https://www6.georgiancollege.ca` &&
        e.origin !== `https://www.georgiancollege.ca` &&
        e.origin !== `https://georgiancollege.ca` &&
        e.origin !== `https://georgiandevenv.wpengine.com` &&
        e.origin !==
        `https://h66piy0e95vn3yjvlgninq4jk.js.wpenginepowered.com` &&
        e.origin !== `https://static.georgiancollege.ca`
      ) {
        return
      }
      if (e.data.source !== `georgian-preview`) return
      const payload = e.data
      // console.log({ payload })
      if (payload.previewHtml) {
        setPreviewHtml(payload.previewHtml)
      }
    }
    window.onmessage = onMessage
    window.parent.postMessage({ source: `georgian-preview` }, `*`)
    return () => {
      window.onmessage = null
    }
  }, [])
  return (
    <>
      {/* {parse(sanitize ? DOMPurify.sanitize(html) : html, options)} */}
      {previewHtml !== null ? (
        <>
          <div className="bg-red-200 border-2 border-red-500 rounded p-4 mb-4">
            <div className="flex items-center">
              <span className="pr-2">Preview Type: </span>
              <button
                className={classNames(
                  `text-white px-2 py-1`,
                  previewType === `draft` ? `bg-green` : `bg-blue`
                )}
                onClick={() => setPreviewType(`draft`)}
              >
                Draft Content
              </button>
              <button
                className={classNames(
                  `text-white px-2 py-1`,
                  previewType === `live` ? `bg-green` : `bg-blue`
                )}
                onClick={() => setPreviewType(`live`)}
              >
                Live Content
              </button>
              <button
                className={classNames(
                  `text-white px-2 py-1`,
                  previewType === `slider` ? `bg-green` : `bg-blue`
                )}
                onClick={() => setPreviewType(`slider`)}
              >
                Comparison Slider
              </button>
            </div>
          </div>
          {previewType === `draft` && parse(previewHtml, options)}
          {previewType === `live` && parse(html, options)}
          {previewType === `slider` && (
            <>
              <ReactCompareSlider
                handle={<ReactCompareSliderHandle style={{ color: `red` }} />}
                style={{ height: pageRef?.current?.offsetHeight }}
                itemOne={
                  <div className="bg-white">{parse(previewHtml, options)}</div>
                }
                itemTwo={<div className="bg-white">{parse(html, options)}</div>}
              />
              <div className="relative">
                <div className="absolute opacity-0" ref={pageRef}>
                  {parse(html, options)}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        parse(html, options)
      )}
      <div
        ref={tocPortalRef}
        id="table-of-contents-portal"
        className="absolute right-4 top-0 h-full border-0"
      ></div>
    </>
  )
}

export const SecondaryWordpressContent = ({
  html,
}: // sanitize = false,
  IWordpressContentProps): JSX.Element => <>{parse(html, options)}</>

interface IHeadingProps {
  domNode: Element
}
const Heading = ({ domNode }: IHeadingProps): JSX.Element => {
  // console.log(`heading`, domNode)
  const Tag = domNode.name as "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
  const id = domNode.attribs.id
  if (Tag !== `h2` || (Tag === `h2` && !id))
    return (
      <Tag {...attributesToProps(domNode.attribs)}>
        {domToReact(domNode.children, options)}
      </Tag>
    )

  const ref = useRef(null)
  const { setHeadingInView, headingInView } = useContext(UserInterfaceContext)
  const isInView = useIsAtViewportTop(ref)

  useEffect(() => {
    const anchor = `#${id}`
    // const parent = domNode?.parent as Element
    if (
      isInView &&
      id &&
      id !== `` &&
      // parent?.attribs?.class?.includes(`wp-block-georgiancollege-page-section`)
      Tag === `h2`
    ) {
      setHeadingInView(anchor)
    }
    if (!isInView && headingInView === anchor) {
      // setHeadingInView(``)
    }
  }, [isInView])
  return (
    <Tag ref={ref} id={id} {...attributesToProps(domNode.attribs)}>
      {domToReact(domNode.children, options)}
    </Tag>
  )
}

interface IAnchorLinkProps {
  domNode: Element
}
const AnchorLink = ({ domNode }: IAnchorLinkProps): JSX.Element => {
  // console.log(`anchor link`, domNode)
  const { headingInView, setHeadingInView, setMobileTocOpen } =
    useContext(UserInterfaceContext)
  return (
    <a
      className={classNames(
        headingInView === domNode.attribs.href ? `active font-bold` : ``
      )}
      {...attributesToProps(domNode.attribs)}
      onClick={(e): void => {
        e.preventDefault()
        // change the scrollTo offset visibility of stick local menu and mobile vs. desktop table of contents
        const tocMobile = document.querySelector(
          `#table-of-contents-mobile > div`
        )
        const stickyNav = document.querySelector(`header + nav.sticky`)
        const yOffset =
          tocMobile && window.getComputedStyle(tocMobile).display === `none`
            ? -32
            : stickyNav &&
              window.getComputedStyle(stickyNav).position === `sticky`
              ? -128
              : -96
        const element = document.querySelector(domNode.attribs.href)
        const y = element
          ? element.getBoundingClientRect().top + window.pageYOffset + yOffset
          : 0
        window.scrollTo({ top: y, behavior: `smooth` })

        history.replaceState({}, ``, domNode.attribs.href)
        setMobileTocOpen(false)
        // setHeadingInView(domNode.attribs.href)
      }}
    >
      {domToReact(domNode.children, options)}
    </a>
  )
}

interface ITableOfContentsProps {
  domNode: Element
}
const TableOfContentsBlock = ({
  domNode,
}: ITableOfContentsProps): JSX.Element => {
  // console.log(`toc block`)
  const { setTocIsInViewport } = useContext(UserInterfaceContext)
  const tocRef = React.useRef<HTMLDivElement>(null)
  const isInView = useIsInViewport(tocRef)

  useEffect(() => {
    setTocIsInViewport(isInView)
  }, [isInView])
  return (
    <>
      <div
        ref={tocRef}
        className={classNames(`wp-block-georgiancollege-table-of-contents`)}
        {...attributesToProps(domNode.attribs)}
      >
        {domToReact(domNode.children, options)}
      </div>
      <StickyTableOfContents>
        {domToReact(domNode.children, options)}
      </StickyTableOfContents>
    </>
  )
}

const StickyTableOfContents = ({
  children,
}: {
  children: Array<DOMNode>
}): JSX.Element => {
  // console.log(`test`)
  const {
    tocPortalRef,
    tocMobilePortalRef,
    tocIsInViewport,
    headerIsInViewport,
    setMobileTocOpen,
    mobileTocOpen,
  } = useContext(UserInterfaceContext)
  return tocPortalRef.current && tocMobilePortalRef.current ? (
    <>
      {ReactDOM.createPortal(
        <Transition
          as={React.Fragment}
          show={!tocIsInViewport && !headerIsInViewport}
          appear
          enter="transform transition duration-50"
          enterFrom="opacity-0 translate-y-12"
          enterTo="opacity-100 translate-y-0"
          leave="transform transition duration-50"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-12"
        >
          <div
            className={classNames(
              `hidden 2xl:block sticky bottom-0 left-0 lg:top-4 lg:right-0 mb-4 border border-white`
            )}
          >
            <div className="rounded rounded-tl-none w-56 bg-lightgray">
              <p className="font-semibold px-4 pt-2">On this page:</p>
              {domToReact([children[1]], options)}
            </div>
          </div>
        </Transition>,
        tocPortalRef.current
      )}
      {ReactDOM.createPortal(
        <Transition
          as={React.Fragment}
          show={!tocIsInViewport && !headerIsInViewport}
          appear
          enter="transform transition duration-50"
          enterFrom="opacity-0 -translate-y-12"
          enterTo="opacity-100 translate-y-0"
          leave="transform transition duration-50"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-12"
        >
          <div
            id="table-of-contents-mobile"
            className={classNames(mobileTocOpen ? `mobileTocOpen` : ``)}
          >
            <div className="2xl:hidden w-full bg-lightgray flex gap-2 align-middle items-center">
              <p className="pl-4 font-semibold my-4 basis-28 grow-0 shrink-0">
                On this page:
              </p>
              <div
                onClick={
                  mobileTocOpen
                    ? undefined
                    : (e): void => {
                      e.preventDefault()
                      e.stopPropagation()
                      setMobileTocOpen(true)
                    }
                }
                className="grow"
              >
                {domToReact([children[1]], options)}
              </div>
              <div
                onClick={(): void => {
                  setMobileTocOpen(!mobileTocOpen)
                }}
                className="px-4 ml-auto my-4"
              >
                <ChevronIcon className="w-4 h-4 rotate-90" />
              </div>
            </div>
          </div>
        </Transition>,
        tocMobilePortalRef.current
      )}
    </>
  ) : (
    <></>
  )
}

export default WordpressContent
